import Debug from 'debug'
import { scaleScore } from '@/app/shared/utils/scale-score'

const debug = Debug('question-score-scaler')

interface Score {
  min: number
  max: number
  raw: number
}

// Calculate scaled score, if input range is partial, use only positive part
export function scaleQuestionScore(input: Score, target: { min: number, max: number}) {

  debug('scaleQuestionScore', input, target)

  const negativeInputMin = input.min < 0
  const positiveInputMax = input.max > 0
  const positiveTargetRange = target.min >= 0 && target.max >= 0

  if (negativeInputMin && positiveInputMax && positiveTargetRange) {
    if (input.raw < 0) {
      return 0
    } else {
      return scaleScore({ min: 0, raw: input.raw, max: input.max }, target)
    }
  }

  return scaleScore(input, target)
}

